import React from 'react';
import { WithIndexContext } from '../common/index-context';
import AppInner from "./app-inner"
import { BrowserRouter } from 'react-router-dom'

const App = (init) => {
  return (
    <BrowserRouter>
      <WithIndexContext init={init}>
        <AppInner />
      </WithIndexContext>
    </BrowserRouter>
  );
};

export default App;
